import { downloadable_files } from './downloadable_files.js';

export const files = {
  namespaced: true,
  modules: {
    downloadable_files,
  },
  state: () => {
    return {};
  },
  getters: {},
  mutations: {},
  actions: {},
};
